module.exports = __webpack_public_path__ + "static/media/family-vacation.e5ba8809.png";